import angular from 'angular';
import { includes, get, clone, isEmpty } from 'lodash';
import '../../services/totem';
import '../../services/place';
import '../../services/device';
import '../../services/errors';
import { localStorage, getTotemInfoByVersion } from '../../utils';

const module = angular.module('whyline.modals.totems', [
  'whyline.components.status',
  'whyline.services.totem',
  'whyline.services.place',
  'whyline.services.device',
  'whyline.services.errors',
  'whyline.services.ticket-template',
  'whyline.services.organization',
]);

const TotemModalController = (
  $scope,
  $timeout,
  $uibModalInstance,
  $translate,
  dialog,
  NotificationService,
  TotemService,
  PlaceService,
  totemId,
  DeviceService,
  ErrorService,
  TicketTemplateService,
  OrganizationService,
) => {
  'ngInject';

  $scope.ticketTemplateSelected = {
    option: null,
  };

  const place = PlaceService.GetCurrent();
  $scope.organization = OrganizationService.GetCurrent();

  $scope.place = place;
  $scope.currentTotemVersion = get(place, 'configuration.currentTotemVersion', 'v1');
  $scope.TotemInfo = getTotemInfoByVersion($scope.currentTotemVersion);
  $scope.hideForTotemV2 = $scope.currentTotemVersion !== 'v2';

  const user = localStorage.get('user');
  $scope.superAdmin = user && user.sudo;

  $scope.cantGiveAppointments = !get(place, 'configuration.canGiveAppointments', false);
  $scope.canViewTotemToggles = get(place, 'configuration.canViewTotemToggles', false);

  const populateAlreadyShown = () => {
    $scope.itemsPopulated = {
      ...$scope.totem.linesPopulated,
      ...$scope.totem.areasPopulated,
      ...$scope.totem.schemasPopulated,
      ...$scope.totem.devicePopulated,
    };
  };
  $scope.ticketTemplateList = [];
  $scope.useSegments = get($scope, 'organization.configuration.queuer.useSegments');

  $scope.arrayExternalIds = [];
  $scope.initialExternalIds = [];
  // $scope.printFromDeviceManager = false;

  const validate = () => {
    const { name, messageDuration, timeoutDuration } = $scope.totem;

    if (!name) {
      NotificationService.Warning($translate.instant('mandatory_totem_name'));
      return false;
    }

    if (name.length < 2) {
      NotificationService.Warning($translate.instant('min_char_name'));
      return false;
    }

    if (
      !$scope.useSegments &&
      !$scope.totem.lines.length &&
      !$scope.totem.areas.length &&
      !$scope.totem.schemas.length
    ) {
      NotificationService.Warning($translate.instant('select_min_fila_area_scheme'));
      return false;
    }

    if (
      !$scope.totem.identificationRequired &&
      !$scope.totem.lines.length &&
      !$scope.totem.areas.length &&
      !$scope.totem.schemas.length
    ) {
      NotificationService.Warning($translate.instant('select_at_least_one_area_or_schema'));
      return false;
    }

    if (messageDuration < 5 || !messageDuration) {
      NotificationService.Warning($translate.instant('totem_message_duration'));
      return false;
    }

    if (timeoutDuration < 30 || !timeoutDuration) {
      NotificationService.Warning($translate.instant('totem_timeout_duration'));
      return false;
    }

    return true;
  };

  const dismissOnError = (err) => {
    const errorMessage = get(err, 'data.message', '');

    if ([401, 403, 404].indexOf(err.status) >= 0) {
      $uibModalInstance.close('cancel');
    } else if (err.status === 409 && errorMessage === 'totem.external-id-already-in-use') {
      const externalIds = get(err, 'data.data.externalIds', []);

      if (externalIds.length) {
        NotificationService.Warning(
          $translate.instant(errorMessage).replace('{externalIds}', externalIds.join(', ')),
        );
      }
    } else {
      ErrorService.handler(err);
    }
  };

  $scope.enableControls = true;

  $scope.toggleJoinLine = () => {
    $scope.enableControls = $scope.totem.joinLine;

    if (!$scope.totem.joinLine && !$scope.totem.confirmAppointment) {
      $scope.totem.confirmAppointment = true;
    } else if ($scope.cantGiveAppointments) {
      $scope.totem.joinLine = true;
      $scope.enableControls = true;
    }
  };

  $scope.toggleConfirmAppointment = () => {
    if (!$scope.totem.joinLine && !$scope.totem.confirmAppointment) {
      $scope.totem.joinLine = true;
      $scope.enableControls = $scope.totem.joinLine;
    } else if ($scope.cantGiveAppointments) {
      $scope.totem.confirmAppointment = true;
    }
  };

  $scope.setDisabledLineFromConfiguration = (line) => {
    if ($scope.totem.mobileApp) {
      line.disableForConfiguration = !line.requestSource.mobileApp
        ? 'No se encuentra habilitado para la app mobile'
        : '';
    } else {
      line.disableForConfiguration = !line.requestSource.totem
        ? 'No se encuentra habilitado para el totem'
        : '';
    }
  };

  $scope.setDisabledAreaFromConfiguration = (area) => {
    if ($scope.totem.mobileApp) {
      area.disableForConfiguration = !(
        area.isWithoutAppointment && area.withoutAppointment.requestSource.mobileApp
      )
        ? 'No se encuentra habilitado para la app mobile'
        : '';
    } else {
      area.disableForConfiguration = !(
        area.isWithoutAppointment && area.withoutAppointment.requestSource.totem
      )
        ? 'No se encuentra habilitado para el totem'
        : '';
    }
  };

  $scope.setDisableServicesFromConfiguration = () => {
    const lines = Object.values($scope.totem.linesPopulated);

    lines.length &&
      lines.forEach((line) => {
        $scope.setDisabledLineFromConfiguration(line);
      });

    const areas = Object.values($scope.totem.areasPopulated);

    areas.length &&
      areas.forEach((area) => {
        $scope.setDisabledAreaFromConfiguration(area);
      });
  };

  TicketTemplateService.GetAllByOrganizationId($scope.place.organizationId).then(
    (ticketTemplates) => {
      $scope.ticketTemplateList = ticketTemplates;
    },
  );

  $scope.mustPrint = false;
  // $scope.showPrintDevice = false;

  if (totemId) {
    TotemService.GetOnePopulatedAsPromiseFromServer(totemId)
      .then((totem) => {
        $timeout(() => {
          $scope.totem = TotemService.Copy(totem);
          $scope.mustPrint = !!totem.deviceId || totem.printFromTotem || totem.printFromBrowser.enable;
          $scope.showLines =
            $scope.totem.mobileApp ? !get($scope, 'organization.configuration.queuer.enableSegmentsForApp') : !get($scope, 'organization.configuration.queuer.useSegments');

          const ticketTemplate = $scope.ticketTemplateList.find(
            (t) => t._id === $scope.totem.ticketTemplate,
          );
          $scope.ticketTemplateSelected.option = ticketTemplate
            ? ticketTemplate
            : $scope.ticketTemplateList[0];

          if (
            typeof $scope.totem.fields === 'undefined' ||
            Object.keys($scope.totem.fields).length == 0
          ) {
            $scope.totem.fields = {
              firstName: true,
              lastName: true,
              phone: true,
              email: true,
              identification: true,
            };
          }

          if (totem.deviceId !== '') {
            DeviceService.GetById(totem.deviceId)
              .then((data) => {
                $timeout(() => {
                  $scope.totem.devicePopulated = {};
                  $scope.totem.devicePopulated[totem.deviceId] = data;
                });
              })
              .catch((error) => {
                if (error.status === 404) {
                  $scope.totem.deviceId = '';
                  $scope.totem.devicePopulated = {};
                }
              });
          } else {
            $scope.totem.devicePopulated = {};
          }
          $scope.disablePhoneInput = $scope.place.requirements.phoneNumber ? true : false;
          $scope.totem.fields.phone = $scope.place.requirements.phoneNumber ? true :  $scope.totem.fields.phone;
          $scope.setDisableServicesFromConfiguration();
          $scope.toggleJoinLine();
          $scope.toggleConfirmAppointment();
          populateAlreadyShown();

          $scope.totem.currentExternalId = '';
          $scope.arrayExternalIds = $scope.totem.externalIds !== undefined
            ? $scope.totem.externalIds.map(externalId => externalId.toLowerCase())
            : [];
          $scope.initialExternalIds = clone($scope.arrayExternalIds).filter(externalId => !isEmpty(externalId));
        });
      })
      .catch((err) => dismissOnError(err));
  } else {
    $scope.ticketTemplateSelected.option = $scope.ticketTemplateList[0];
    $scope.totem = {
      name: '',
      lines: [],
      areas: [],
      schemas: [],
      deviceId: '',
      devicePopulated: {},
      linesPopulated: {},
      areasPopulated: {},
      schemasPopulated: {},
      mobileApp: false,
      joinLine: true,
      confirmAppointment: true,
      messageDuration: 5,
      timeoutDuration: 30,
      showComeBackAt: false,
      ticketTemplate: '',
      printFromTotem: false,
      printFromBrowser: {
        enable: false,
        cssProperties: {
          width: "350px",
          spacing: "20px",
          fontSizeFooter: "10px"
        }
      },
      printUrl: '',
      fields: {
        firstName: true,
        lastName: true,
        phone: true,
        email: true,
        identification: true,
      },
      hasIdFirst: false,
      currentExternalId: '',
      externalIds: [],
      identificationRequired: true
    };
  }

  $scope.save = () => {
    if (validate()) {
      if (!$scope.totem.joinLine) {
        $scope.totem.lines = [];
        $scope.totem.areas = [];
        $scope.totem.schemas = [];
      }
      $scope.totem.ticketTemplate = $scope.ticketTemplateSelected.option
        ? $scope.ticketTemplateSelected.option._id
        : null;

      if (totemId) {
        return TotemService.Update($scope.totem)
          .then(() => {
            NotificationService.Success($translate.instant('totem_update_succ'));
            $uibModalInstance.close('cancel');
          })
          .catch((err) => dismissOnError(err));
      }

      return TotemService.Create($scope.totem)
        .then(() => {
          NotificationService.Success($translate.instant('totem_create_succ'));
          $uibModalInstance.close('cancel');
        })
        .catch((err) => dismissOnError(err));
    }
  };

  $scope.cancel = () => {
    $uibModalInstance.close('cancel');
  };

  $scope.selectLine = (selection) => {
    const id = selection._id;
    switch (selection.type) {
      case 'line':
        if (!includes($scope.totem.lines, selection._id)) {
          $scope.totem.lines.push(id);
          $scope.totem.linesPopulated[id] = selection;
          $scope.setDisabledLineFromConfiguration(selection);
          populateAlreadyShown();
        }
        break;
      case 'area':
        if (!includes($scope.totem.areas, selection._id)) {
          $scope.totem.areas.push(id);
          $scope.totem.areasPopulated[id] = selection;
          $scope.setDisabledAreaFromConfiguration(selection);
          populateAlreadyShown();
        }
        break;
      case 'sector':
        if (!includes($scope.totem.schemas, selection._id)) {
          $scope.totem.schemas.push(id);
          $scope.totem.schemasPopulated[id] = selection;
          populateAlreadyShown();
        }
        break;
      case 'device':
        if ($scope.totem.deviceId === '') {
          $scope.totem.deviceId = selection._id;
          $scope.totem.devicePopulated[id] = selection;
          populateAlreadyShown();
        }
        break;
      default:
        return NotificationService.Error($translate.instant('ups_some_wrong'));
    }
  };

  $scope.remove = (id) => {
    const lineIndex = $scope.totem.lines.indexOf(id);
    if (lineIndex >= 0) {
      $scope.totem.lines.splice(lineIndex, 1);
      $scope.totem.linesPopulated[id] = undefined;
      Reflect.deleteProperty($scope.totem.linesPopulated, id);
      populateAlreadyShown();
    }
    const areaIndex = $scope.totem.areas.indexOf(id);
    if (areaIndex >= 0) {
      $scope.totem.areas.splice(areaIndex, 1);
      $scope.totem.areasPopulated[id] = undefined;
      Reflect.deleteProperty($scope.totem.areasPopulated, id);
      populateAlreadyShown();
    }
    const schemaIndex = $scope.totem.schemas.indexOf(id);
    if (schemaIndex >= 0) {
      $scope.totem.schemas.splice(schemaIndex, 1);
      $scope.totem.schemasPopulated[id] = undefined;
      Reflect.deleteProperty($scope.totem.schemasPopulated, id);
      populateAlreadyShown();
    }

    const deviceIndex = $scope.totem.deviceId.includes(id);
    if (deviceIndex) {
      $scope.totem.deviceId = '';
      $scope.totem.devicePopulated[id] = undefined;
      Reflect.deleteProperty($scope.totem.devicePopulated, id);
      populateAlreadyShown();
    }
  };

  $scope.toggleMustPrint = () => {
    $scope.mustPrint = !$scope.mustPrint;
  };

  $scope.inputExternalId = event => {
    if (
      (event.which === 188 && !$scope.checkLessThanCharacter()) ||
      (event.which === 13 && $scope.totem.currentExternalId !== ' ')
    ) {
      let externalId = $scope.totem.currentExternalId.indexOf(',') !== -1
        ? $scope.totem.currentExternalId.substring(0, $scope.totem.currentExternalId.indexOf(','))
        : $scope.totem.currentExternalId;

			if (!isEmpty(externalId)) {
				if ($scope.arrayExternalIds.indexOf(externalId.toLowerCase()) === -1) {
					$scope.totem.externalIds.push(externalId.toLowerCase());
					$scope.arrayExternalIds.push(externalId.toLowerCase());
				}
      }

      $scope.totem.currentExternalId = '';
    }
  };

  $scope.removeExternalId = externalId => {
		if ($scope.initialExternalIds.indexOf(externalId.toLowerCase()) !== -1) {
			dialog
				.confirm($translate.instant('external_id_remove'))
				.then(() => $scope.deleteExternalId(externalId))
				.catch(() => 'canceled');
		} else {
			$scope.deleteExternalId(externalId);
		}
	};

	$scope.deleteExternalId = externalIdToRemove => {
		$scope.totem.externalIds = $scope.totem.externalIds.filter(externalId => externalId !== externalIdToRemove.toLowerCase());
		$scope.arrayExternalIds = $scope.arrayExternalIds.filter(externalId => externalId !== externalIdToRemove.toLowerCase());
		$scope.initialExternalIds = $scope.initialExternalIds.filter(externalId => externalId !== externalIdToRemove.toLowerCase());
	};

  $scope.checkLessThanCharacter = () => {
    return /^(<)\1*$/.test($scope.totem.currentExternalId) || $scope.totem.currentExternalId.endsWith('<');
  };
};

module.exports = module.controller('TotemModalController', TotemModalController);
